var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2.50012C13.8284 2.50012 14.5 3.17169 14.5 4.00012V7.00012H11.5V4.00012C11.5 3.17169 12.1716 2.50012 13 2.50012ZM27 2.50012C27.8284 2.50012 28.5 3.17169 28.5 4.00012V7.00012H25.5V4.00012C25.5 3.17169 26.1716 2.50012 27 2.50012ZM10 11.8335C8.61929 11.8335 7.5 12.9527 7.5 14.3335V16.1668H32.5V14.3335C32.5 12.9527 31.3807 11.8335 30 11.8335H10ZM4.5 14.3335C4.5 11.2959 6.96243 8.83346 10 8.83346H30C33.0376 8.83346 35.5 11.2959 35.5 14.3335V33.0001C35.5 36.0377 33.0376 38.5001 30 38.5001H10C6.96243 38.5001 4.5 36.0377 4.5 33.0001V14.3335ZM7.5 19.1668V33.0001C7.5 34.3808 8.61929 35.5001 10 35.5001H30C31.3807 35.5001 32.5 34.3808 32.5 33.0001V19.1668H7.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.05707eab047178cc1d91067565cc7bb8.svg";
export { ForwardRef as ReactComponent };